import React, { ReactNode } from 'react';
import { ProjectProvider } from './ProjectContext';
import { FileTreeProvider } from './FileTreeContext';
import { CollabProvider } from './CollabContext';
import { GlobalProvider } from './GlobalContext';
import { AuthProvider } from './AuthContext';
import { YjsDocumentProvider } from './YjsDocumentContext';


// Wrap all global-level context providers that are required across the app.
export const GlobalWrapper = ({ children }: { children: ReactNode }) => {
  return (
     <GlobalProvider>
      <AuthProvider>
        <YjsDocumentProvider>
          <ProjectProvider>
            <FileTreeProvider>
              <CollabProvider>
                {children}
              </CollabProvider>
            </FileTreeProvider>
          </ProjectProvider>
        </YjsDocumentProvider>
      </AuthProvider>
    </GlobalProvider>
  );
};